import { combineReducers } from 'redux'

import apiCallsInProgress from './apiStatusReducer'
import { configReducer } from './configReducer'
import { endorsementKeysReducer } from './endorsementKeysReducers'
import { entraIdRolesReducer } from './entraIdRolesReducer'
import { identityReducer } from './identityReducer'
import {
  ConfigurationState,
  DeviceKeyMappingInfo,
  DeviceKeyMappingsState,
  EntraIdRolesState,
  IdentityState,
  KeysReducerState,
  UsagePermissionsState,
  UserPermissionsState,
} from './initialState'
import {
  getKeyMappingsRequestReducer,
  keyMappingsPageNumReducer,
  keyMappingsReducer,
} from './keyMappingsReducer'
import { keyReducer } from './keyReducer'
import { signingKeysReducer } from './signingKeysReducer'
import { usagePermissionsReducer } from './usagePermissionsReducer'
import { getUserPermissionsReducer } from './userPermissionsReducer'

export interface IRootState {
  keys: KeysReducerState
  apiCallsInProgress: number
  identity: IdentityState | null
  userPermissions: UserPermissionsState | null
  keyMappings: DeviceKeyMappingsState
  searchMappingRequest: DeviceKeyMappingInfo
  keyMappingsPageNum: number
  usagePermissions: UsagePermissionsState
  signingKeys: KeysReducerState
  endorsementKeys: KeysReducerState
  entraIdRoles: EntraIdRolesState
  configuration: ConfigurationState | null
}

const rootReducer = combineReducers<IRootState>({
  keys: keyReducer,
  apiCallsInProgress,
  identity: identityReducer,
  userPermissions: getUserPermissionsReducer,
  keyMappings: keyMappingsReducer,
  searchMappingRequest: getKeyMappingsRequestReducer,
  keyMappingsPageNum: keyMappingsPageNumReducer,
  usagePermissions: usagePermissionsReducer,
  signingKeys: signingKeysReducer,
  endorsementKeys: endorsementKeysReducer,
  entraIdRoles: entraIdRolesReducer,
  configuration: configReducer,
})

export default rootReducer
